<template lang="html">
    <section class="order-message">
        <div class="message-bloc">
            <p>{{ $t("orders.message.textMessage") }}</p>
            <div class="message-groupe">
                <div class="groupe message-groupe-user">
                    <span>{{ rem3rchUser.user.initial }}</span>
                </div>
                <div class="groupe message-groupe-input"><textarea :class="{ emptyMsg: classError }" rows="6" v-model="messageContent" /></div>
                <div class="groupe message-groupe-btn">
                    <button class="btn btn-send" @click="sendMessageOrder();">{{ $t("orders.message.btnSen") }}</button>
                </div>
            </div>
        </div>
        <div class="order-ref" v-if="order.purchaseOrderNumber">
            <span class="order-ref-label">{{ $t("orders.labelPurchase") }}: </span>
            <span class="purchaseOrderNumber">{{ order.purchaseOrderNumber }}</span>
        </div>
        <div class="order-history">
            <h2 class="order-history-title">{{ $t("orders.message.history") }}</h2>
            <div v-if="dataCommentToSorted" v-for="comment in dataCommentToSorted" :key="comment.id" class="order-history-message">
                <div>
                    <div class="order-bloc order-history-message-user">
                        <span v-if="comment.createdBy.initial" :class="{ statusMessage: comment.message === null }">{{
                            comment.createdBy.initial
                        }}</span>
                    </div>
                    <div class="order-bloc order-history-message-content">
                        <div class="created-message">
                            <span class="user-history">
                                {{ comment.createdBy.initial }} ({{ comment.createdBy.firstname }} {{ comment.createdBy.lastname }})
                            </span>
                            <span v-if="comment.orderStatus" class="historyTypeStatus">
                                {{ getTranslate(comment.orderStatus.terms.name) }}
                                <span v-if="comment.orderStatus.terms.reference_status === 'shipping_cost_added'" class="infos">
                                    : {{ comment.data.shippingCost | CurrencyCustomPipe("en-US", currencyBrand.shortName) }} by
                                    {{ comment.data.shippingMethod }}
                                </span>
                            </span>

                            <span v-if="comment.orderAction" class="infos-history">
                                {{ comment.content.terms }} : <span class="infos" v-html-safe="comment.content.infos"></span>
                            </span>
                        </div>

                        <p class="message" v-if="comment.message">{{ comment.message }}</p>
                    </div>
                    <div class="order-bloc order-history-message-created-date">
                        <span>{{ convertGmtToLocal(new Date(comment.createdAt)).toLocaleString() }}</span>
                        <span>{{ timeAgo(comment.interval) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {mapActions, mapGetters} from 'vuex'
import Globals from "../../../components/globals";
import cacheService from "@/services/cache";

export default {
    name: 'order-message',
    props: ["dataComments", "currencyBrand"],
    mounted() {
    },
    data() {
        return {
            messageContent: "",
            classError: false,
            rem3rchUser: {},
            dataHistory: []
        }
    },
    methods: {
        ...mapActions("order", {
            sendMessage: 'details/sendMessage'
        }),
        sendMessageOrder() {
            if (this.messageContent) {
                this.classError = false
                let objMessage = {
                    message: this.messageContent,
                    languageCode: cacheService.getUserLang()
                }
                try {
                    this.sendMessage(objMessage);
                }
                catch (e) {
                    console.log(e);
                }
                this.messageContent = ""
            } else {
                this.classError = true
            }
        },
        /**
         * Convert Date GTM to Local
         * @param dateGmt
         * @returns {Date}
         */
        convertGmtToLocal(dateGmt) {
            let newDate = new Date(dateGmt.getTime() + dateGmt.getTimezoneOffset() * 60000)

            let offset = dateGmt.getTimezoneOffset() / 60
            let hours = dateGmt.getHours()

            newDate.setHours(hours - offset)

            return newDate
        },
        timeAgo(timeData) {
            let intervalValues = ["year", "month", "day", "hour", "minute", "second"];
            for (let i = 0; i < intervalValues.length; i++) {
                if (timeData[intervalValues[i]] > 0) {
                    return this.$t("orders.timeAgo." + intervalValues[i]).replace('{time}', timeData[intervalValues[i]])
                }
            }
        },
        historyMap() {
            this.dataHistory = this.dataComments.map(v => {
                 return {
                     createdAt: v.createdAt,
                     createdBy: v.createdBy,
                     data: v.data,
                     id: v.id,
                     interval: v.interval,
                     message: v.message,
                     orderAction: v.orderAction,
                     orderStatus: v.orderStatus,
                     content: v.orderAction ? {
                         terms: this.$t("orders.historyAction." + v.orderAction.name),
                         infos : v.orderAction.name === "purchase_order_added" || v.orderAction.name === "purchase_order_updated"
                             ? v.data.purchaseOrder
                             : v.orderAction.name === "delivery_address_added" || v.orderAction.name === "delivery_address_updated"
                                 ? v.data.deliveryAddress
                                 : v.orderAction.name === 'shipping_method_cost_updated'
                                     ? Globals.CurrencyCustomPipe(v.data.shippingCost, "en-US", this.currencyBrand.shortName) + " by " + v.data.shippingMethod
                                     : null
                     } : null,
                 }
            })
        }
    },
    computed: {
        ...mapGetters("order", {
            order: "details/getOrder"
        }),
        dataCommentToSorted() {
            this.historyMap();
            return this.dataHistory ? this.dataHistory.slice().sort(function (a, b) {
                return b.id - a.id
            }) : []
        }
    },
    created() {
        this.rem3rchUser = cacheService.getRem3rchUser();
    }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";

.order-message {
    & .order-history {
        @extend %primary-text;
        &-title {
            font-size: 18px;
            font-family: "oswald-regular", sans-serif;
            text-transform: uppercase;
            font-weight: normal;
        }
        &-message {
            padding: 10px 0;
            border-bottom: 1px solid #ccc;
            &:last-child {
                border-bottom: none;
            }
            .created-message {
                & > span {
                    font-size: 13px;
                }
                .historyTypeStatus {
                }
                .user-history {
                }
                .infos {
                    color: $color4;
                    text-transform: none;
                }
            }
            .infos-history {
                text-transform: none;
            }
            &-content {
                width: calc(100% - (50px + 130px));
                @media only screen and (max-width: 767px) {
                    width: calc(100% - 50px);
                }
                & .message {
                    font-size: 13px;
                    margin: 5px 0;
                    font-family: "oswald-regular", sans-serif;
                    width: 90%;
                }
            }
            &-created-date {
                text-align: right;
                @media only screen and (max-width: 767px) {
                    display: block;
                    text-align: left;
                    margin-left: 45px;
                    margin-top: 10px;
                }
                & span {
                    display: block;
                    font-size: 12px;
                    text-transform: none;
                }
            }
            &-user {
                margin-right: 10px;
                & span {
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    background-color: black;
                    color: white;
                    font-size: 10px;
                    text-align: center;
                    vertical-align: middle;
                    display: table-cell;
                    &.statusMessage {
                        background-color: $color4;
                    }
                }
            }
            & .order-bloc {
                display: inline-block;
                vertical-align: top;
            }
        }
    }
    & .order-ref {
        @extend %primary-text;
        &-label {
            text-transform: uppercase;
            font-weight: bold;
            font-size: 12px;
        }
        .purchaseOrderNumber {
            text-transform: initial;
        }
    }
    & .message-bloc {
        padding: 10px;
        background-color: #ccc;
        margin: 20px 0;
        & p {
            margin: 0 0 10px 0;
        }
    }
    & .message-groupe {
        &:after {
            content: "";
            display: block;
            clear: both;
        }
        & .groupe {
            display: inline-block;
            margin-right: 10px;
            &:last-child {
                margin-right: 0;
            }
        }
        &-user {
            vertical-align: top;
            position: relative;
            top: 5px;
            & span {
                border-radius: 50%;
                width: 30px;
                height: 30px;
                background-color: black;
                color: white;
                font-size: 10px;
                display: block;
                text-align: center;
                line-height: 27px;
            }
        }
        &-input {
            width: calc(100% - (40px + 80px + 10px));
            @media only screen and (max-width: 767px) {
                width: calc(100% - 50px);
                margin-right: 0 !important;
            }
            & textarea {
                width: 100%;
                @extend %primary-text;
                @extend %primary-background;
                &.emptyMsg {
                    border: 1px solid red;
                }
            }
        }
        &-btn {
            position: relative;
            top: -10px;
            @media only screen and (max-width: 767px) {
                width: 100%;
                top: 0;
                text-align: center;
                margin-top: 20px;
            }
            & .btn-send {
                background-color: $color4;
                border-color: $color4;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// OrderMessage.vue?6f5ab15e